<script lang="ts">import { stateHasSports } from "@infinitro/config";
import { loggedIn } from "@infinitro/global";
import BigLeftCardLogged from "./parts/big-left-card-logged.svelte";
import BigLeftCard from "./parts/big-left-card.svelte";
import BigRightCard from "./parts/big-right-card.svelte";
import SmallBottomLeftCardFallback from "./parts/small-bottom-left-card-fallback.svelte";
import SmallBottomLeftCard from "./parts/small-bottom-left-card.svelte";
import SmallBottomRightCard from "./parts/small-bottom-right-card.svelte";
import SmallTopLeftCard from "./parts/small-top-left-card.svelte";
import SmallTopRightCard from "./parts/small-top-right-card.svelte";
</script>

<div class="top-section">
	<div class="first-row">
		<div class="first-column">
			{#if $loggedIn}
				<BigLeftCardLogged />
			{:else}
				<BigLeftCard />
			{/if}
		</div>
		<div class="second-column">
			<BigRightCard />
		</div>
	</div>
	<div class="second-row">
		<SmallTopLeftCard />
		{#if $stateHasSports}
			<SmallBottomLeftCard />
		{:else}
			<SmallBottomLeftCardFallback />
		{/if}
	</div>
	<div class="third-row">
		<SmallBottomRightCard />
		<SmallTopRightCard />
	</div>
</div>

<style>
	.top-section {

		display: flex;

		height: 100%;

		min-height: 300px;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 0.5rem
}

	@media (min-width: 768px) {
		.top-section {

				gap: 0.75rem
		}
	}

	.first-row,
	.second-row,
	.third-row {

		display: flex;

		width: 100%;

		align-items: center;

		justify-content: space-between;

		gap: 0.5rem
}

	@media (min-width: 768px) {
		.third-row {

				gap: 0.75rem
		}
	}

	.first-row {

		height: 190px
}

	.second-row {

		height: 96px
}

	.third-row {

		height: 96px
}

	.first-column,
	.second-column {

		display: flex;

		height: 100%;

		flex-direction: column;

		align-items: center;

		justify-content: center;

		gap: 1rem;

		width: 50%
}

	@media (min-width: 640px) and (max-width: 1280px) {
		.first-row {

				height: 300px
		}

		.second-row,
		.third-row {

				height: 182px
		}
	}
</style>
